import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ROUTES } from '../../../../src/app/app-routes.constant';

@Component({
    selector: 'dd-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    standalone: false
})
export class NotFoundComponent {
  router = inject(Router);

  goHome() {
    this.router.navigateByUrl(ROUTES.HOME);
  }

}
